export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8358.1c1e6d95.jpg";